import clsx from 'clsx'
import {FC, useId} from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useAuth} from '../../../../../app/modules/auth'
import {UserCompanyModel} from '../../../../../app/modules/auth/core/_models'
import {
  StaffSessionModel,
  staffPicksBusiness,
} from '../../../../../app/modules/auth/core/staffAccess'

type FilterUser = {
  rl?: number
  cpi?: number
  cpl?: UserCompanyModel[]
  support?: unknown
  staff?: StaffSessionModel | null
}

/**
 * Whether the session is staff whose selected business narrows the pages with the business picker
 * («کسب‌وکارها» granted in the CRM; a support session is never staff).
 */
export const hasAdminBusinessFilter = (user?: FilterUser | null) =>
  !!user && !user.support && staffPicksBusiness(user)

/** The selected business's name, or '' when the administrator has none selected. */
export const adminBusinessFilterName = (user?: FilterUser | null) => {
  const companyId = Number(user?.cpi || 0)
  if (companyId <= 0) return ''
  const name = user?.cpl?.find((company) => Number(company.id) === companyId)?.nm?.trim()
  return name || `کسب‌وکار ${companyId}`
}

/**
 * The on/off mark beside a sidebar entry whose page follows the administrator's selected business:
 * lit while a business is selected (its name in the tooltip), dim while every business is shown.
 * The selection is one for all those pages, so picking a business on one lights every mark.
 */
const AdminBusinessFilterIndicator: FC = () => {
  const {currentUser} = useAuth()
  const tooltipId = useId()
  if (!hasAdminBusinessFilter(currentUser as FilterUser | undefined)) return null

  const name = adminBusinessFilterName(currentUser as FilterUser | undefined)
  const active = name.length > 0
  return (
    <OverlayTrigger
      placement='left'
      overlay={<Tooltip id={tooltipId}>{active ? name : 'بدون فیلتر کسب‌وکار'}</Tooltip>}
    >
      <span
        className={clsx('mp-business-filter', {'is-active': active})}
        role='img'
        aria-label={active ? `فیلتر کسب‌وکار: ${name}` : 'بدون فیلتر کسب‌وکار'}
      >
        <i className='la la-filter' aria-hidden='true' />
      </span>
    </OverlayTrigger>
  )
}

export {AdminBusinessFilterIndicator}
